export default {
    corruptedFile: 'corruptedFile',
    error: 'error',
    deletedExcelTemplate: 'deletedExcelTemplate',
    deletedPublicTable: 'deletedPublicTable',
    deletedPublicForm: 'deletedPublicForm',
    deletedExportTemplate: 'deletedExportTemplate',
    deletedSmsTemplate: 'deletedSmsTemplate',
    deletedEmailTemplate: 'deletedEmailTemplate',
    verifyError: 'verifyError',
    userNameExists: 'userNameExists',
    excelImportNoMapping: 'excelImportNoMapping',
    linkedfieldOptionsError: "linkedfieldOptionsError",
	duplicateRecordSuccess: 'duplicateRecordSuccess',
	userExists: 'userExists',
	registrationError: 'registrationError',
	loginError: 'loginError'
}
